import {
  FORM_ALL,
  FORM_GET,
  FORM_PUT,
  FORM_DEL,
  FORM_POST,
  FORM_LOADING,
  FORM_ERROR,
} from '../../actions/types'

const initialState = {
  form: null,
  isLoading: true,
  isCompleted: true,
}
export default function (state = initialState, action) {
  switch (action.type) {
    case FORM_ALL:
      return {
        arr: [...action.payload],
        isLoading: false,
        isCompleted: true,
      }
    case FORM_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      }
    case FORM_POST:
      return { isLoading: false, isCompleted: true }
    case FORM_PUT:
      return { isLoading: false, isCompleted: true }
    case FORM_DEL:
      return { isLoading: false, isCompleted: true }
    case FORM_LOADING:
      return { isLoading: true, isCompleted: false }
    case FORM_ERROR:
      return { isLoading: false, isCompleted: false }
    default:
      return state
  }
}
